import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ContactingModalWrapper } from "@/components/contacting";
import { ApplicationRouter } from "@/app/router";
import { useCustomerActionExposeSectionView } from "@/hooks/tracking/customerActions/useCustomerAction";
import { useEffect } from "react";
import { useClassifiedAnalytics } from "@/hooks/tracking/classifiedAnalytics/useClassifiedAnalytics";
import { useClassifiedId } from "@/contexts/classified/hooks";
import { useShouldStoreToSeenContext } from "@/contexts/seen/hooks";
import { useTrackingLegacyView } from "@/hooks/tracking/trackingLegacy/useTrackingLegacyView";
import { useTrackingView } from "@/hooks/tracking/useTrackingView";
import { CA_EVENT_TYPES } from "@/types/classifiedAnalytics";
import { saveSeenToStorage } from "@/utils/saveContactAndSeenToStorage/saveContactAndSeenToStorage";
export const ApplicationWrapper = () => {
    const { sendClassifiedAnalyticsEvent } = useClassifiedAnalytics();
    const classifiedId = useClassifiedId();
    const { shouldStoreToSeen } = useShouldStoreToSeenContext();
    useEffect(() => {
        if (!shouldStoreToSeen || !classifiedId)
            return;
        const timer = setTimeout(() => {
            // @ts-ignore
            saveSeenToStorage(classifiedId);
        }, 5000);
        return () => clearTimeout(timer);
    }, [classifiedId, shouldStoreToSeen]);
    // Legacy tracking solution on French brands also known as "Harvest"
    useTrackingLegacyView();
    useTrackingView();
    // wl classified analytics call
    useEffect(() => {
        sendClassifiedAnalyticsEvent(CA_EVENT_TYPES.PAGE_VIEW);
    }, [sendClassifiedAnalyticsEvent]);
    // Legacy tracking solution on German brands
    useCustomerActionExposeSectionView();
    return (_jsxs(_Fragment, { children: [_jsx(ContactingModalWrapper, {}), _jsx(ApplicationRouter, {})] }));
};
